const MessageError = ({ error }) => (
  <div className="alert alert-danger">{error.graphQLErrors.map(({ message }) => (
    <span key={message}>{message}</span>
  ))}
  </div>
)

export default MessageError
